import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { Form, TextInputControl } from '@/core/components';

import { useCurrentUser } from '@/feature/security';
import { JobTitleSelectControl } from '@/feature/utils';

import { UpdateProfileRequest } from '../model/DashboardTypes';

interface UpdateProfileFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: UpdateProfileRequest) => void;
}

export const updateProfileSchema = z.object({
  firstName: z.string().trim(),
  lastName: z.string().trim(),
  jobTitle: z.string().trim(),
});

type UpdateProfileSchema = z.infer<typeof updateProfileSchema>;

export function UpdateProfileForm(props: UpdateProfileFormProps) {
  const user = useCurrentUser();
  const { onClose, isSubmitting, onChange } = props;
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<UpdateProfileSchema>({
    defaultValues: { firstName: user.firstName, lastName: user.lastName, jobTitle: user.jobTitle },
    resolver: zodResolver(updateProfileSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('profile.updateProfile')}
    >
      <Form
        onSubmit={handleSubmit(onChange)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <TextInputControl
          label={t('profile.update.firstName')}
          name="firstName"
          control={control}
          isSubmitting={isSubmitting}
        />
        <TextInputControl
          label={t('profile.update.lastName')}
          name="lastName"
          control={control}
          isSubmitting={isSubmitting}
        />

        <JobTitleSelectControl
          label={t('profile.update.jobTitle')}
          name="jobTitle"
          control={control}
          isSubmitting={isSubmitting}
        />
      </Form>
    </Modal>
  );
}
